


export const urlGetParamsGetter = (param) => {
  const currentUrl = window.location.href;
  const searchParams = new URLSearchParams(new URL(currentUrl).search)
  const value = searchParams.get(param)
  if (value) return value
  return null
}